import OrganizationCard from "./OrganizationCard";

export default OrganizationCard;
